import { fb, validators } from 'form';
import { categories } from 'site/data';

export function getProductEditModel(data) {
  let categoryList = categories.map((x) => { return { name: x.category, value: x.category } });
  categoryList = [{ name: 'Select...', value: '' }, ...categoryList];
  
  const statusList = [{ name: 'Live', value: '0' }, { name: 'Archive', value: '99' }, { name: 'Discontinued', value: '98' }];

  console.log('getProductEditModel', data)

  const model = fb.group({
    productStatus: [data.productStatus || '0', [validators.Required()], { type: 'select', options: statusList }],
    productCode: [data.productCode || '', [validators.Required()], { type: 'text' }],
    productName: [data.productName || '', [validators.Required()], { type: 'text' }],
    category: [data.category || '', [validators.Required()], { type: 'select', options: categoryList }],
    //productUrl: [data.productUrl || '', [validators.Required()], { type: 'text' }],
  })

  return model;
}
